angular.module('iqxCore')
.filter('removespaces', function(){
  return function(input){
    var output=input.replace(/\s/g, '');
    return output;
  }
})